function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_6653",
  "data-name": "Grupo 6653",
  transform: "translate(-178.814 -26.397)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5975",
  "data-name": "Caminho 5975",
  d: "M218.215,30.657a2.461,2.461,0,0,0-1.893-1.61l-16.4-2.6a1.389,1.389,0,0,0-.769,0l-16.477,2.59a2.357,2.357,0,0,0-1.893,1.61,33.82,33.82,0,0,0-1.965,11.5A34.579,34.579,0,0,0,198.446,73.49a2.99,2.99,0,0,0,1.052.283,1.981,1.981,0,0,0,1.052-.283,34.554,34.554,0,0,0,19.632-31.338A33.821,33.821,0,0,0,218.215,30.657ZM200.383,69.174a1.668,1.668,0,0,1-.885.238,2.518,2.518,0,0,1-.885-.238,29.116,29.116,0,0,1-16.53-26.392,28.478,28.478,0,0,1,1.655-9.679,1.985,1.985,0,0,1,1.594-1.356l13.873-2.18a1.171,1.171,0,0,1,.648,0l13.812,2.186a2.072,2.072,0,0,1,1.594,1.356,28.476,28.476,0,0,1,1.655,9.679A29.094,29.094,0,0,1,200.383,69.174Z",
  fill: "#002042"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_5976",
  "data-name": "Caminho 5976",
  d: "M305.791,189.863a2.223,2.223,0,0,1-1.516-.6L298.632,184a2.223,2.223,0,0,1,3.032-3.252l3.965,3.7,10.237-11.706a2.223,2.223,0,0,1,3.347,2.927L307.465,189.1a2.222,2.222,0,0,1-1.56.757C305.867,189.862,305.829,189.863,305.791,189.863Z",
  transform: "translate(-108.59 -132.728)",
  fill: "#002042"
}));

var SvgIconSecurity = function SvgIconSecurity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41.366,
    height: 47.376,
    viewBox: "0 0 41.366 47.376",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSecurity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-security.6412f82e.svg";
export { ForwardRef as ReactComponent };